var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCf5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(-494 -1184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    transform: "translate(494 1184)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "id-card_2_",
    "data-name": "id-card (2)",
    transform: "translate(493.5 1186.233)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y1: 3,
    x2: 2,
    transform: "translate(26.5 0.767)",
    fill: "none",
    stroke: "#424a60",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M36.294,5H11.933A1.437,1.437,0,0,0,10.5,6.433V42.259a1.437,1.437,0,0,0,1.433,1.433H36.294a1.437,1.437,0,0,0,1.433-1.433V6.433A1.437,1.437,0,0,0,36.294,5ZM24.114,11.449a2.15,2.15,0,1,1,2.15-2.15A2.149,2.149,0,0,1,24.114,11.449Z",
    transform: "translate(0 -1.134)",
    fill: "#e7eced"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 4,
    y2: 8,
    transform: "translate(20.5 0.767)",
    fill: "none",
    stroke: "#424a60",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 13,
    height: 12,
    transform: "translate(17.5 13.767)",
    fill: "#efce4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M33.547,42.433H19.217a.717.717,0,0,1,0-1.433h14.33a.717.717,0,0,1,0,1.433Z",
    transform: "translate(-2.268 -11.34)",
    fill: "#424a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M33.547,47.433H19.217a.717.717,0,1,1,0-1.433h14.33a.717.717,0,1,1,0,1.433Z",
    transform: "translate(-2.268 -12.757)",
    fill: "#424a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M33.547,52.433H19.217a.717.717,0,1,1,0-1.433h14.33a.717.717,0,1,1,0,1.433Z",
    transform: "translate(-2.268 -14.174)",
    fill: "#424a60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(20.531 15.622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(-0.031 0.145)",
    fill: "#dc691d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M28.083,30A3.583,3.583,0,0,0,24.5,33.583V34.3h7.165v-.717A3.583,3.583,0,0,0,28.083,30Z",
    transform: "translate(-24.5 -23.843)",
    fill: "#dc691d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf5);
export default __webpack_public_path__ + "static/media/cf5.4e0d6a858f6e9bcbf66e4d4b195085cb.svg";
export { ForwardRef as ReactComponent };